<div class="sidenav" fxLayout="column">
  <div [routerLink]="['/']" class="sidenav-toolbar" fxLayout="row" fxLayoutAlign="center center">
    <div>
      <img *ngIf="(authenticationService.organisation$ | async)"
           alt="{{ (authenticationService.organisation$ | async).display_name }}"
           class="sidenav-toolbar-logo"
           src="{{ (authenticationService.organisation$ | async).logo }}"
           id="logo"
      >
      <img *ngIf="!(authenticationService.organisation$ | async)"
           alt="Straatbeeld Online"
           class="sidenav-toolbar-logo"
           src="/assets/img/logo.png"
           id="logo"
      >
    </div>

    <span fxFlex><!-- fill space --></span>
  </div>

  <fury-scrollbar class="sidenav-items" fxFlex="auto">
    <p>Op deze kaart staan meldingen in de openbare ruimte waarmee we aan het werk zijn. Vanwege privacy staat een klein deel van de meldingen niet op de kaart.</p>
    <mat-form-field>
      <mat-label>Zoom naar adres</mat-label>
      <input matInput [formControl]="address" [matAutocomplete]="addressAutocomplete">
      <mat-autocomplete #addressAutocomplete="matAutocomplete" [displayWith]="formatAddress">
        <mat-option *ngFor="let option of addressSuggestions" [value]="option">
          {{ option.weergavenaam }}
        </mat-option>
        <mat-option *ngIf="addressSuggestionsNoResults">
          Er zijn geen resultaten gevonden, probeer een ander naam.
        </mat-option>
        <mat-spinner *ngIf="addressSuggestionsLoading" diameter="20"></mat-spinner>
      </mat-autocomplete>
      <button *ngIf="address.value" mat-icon-button matSuffix (click)="clear()">
        <mat-icon>clear</mat-icon>
      </button>
      <button *ngIf="!address.value" mat-icon-button matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    <fury-sidenav-item *ngFor="let item of sidenavService.menuItems" [item]="item"></fury-sidenav-item>
  </fury-scrollbar>
</div>
